import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["disabled", "title"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "icon-edit" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["disabled", "title"]
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Name", -1)
const _hoisted_7 = { class: "control" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Description", -1)
const _hoisted_11 = { class: "control" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.mode === 'edit')
      ? (_openBlock(), _createElementBlock("button", _mergeProps({
          key: 0,
          class: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal = _ctx.allowOpen))
        }, _ctx.$attrs, {
          disabled: !_ctx.allowOpen || undefined,
          title: _ctx.openButtonTitle
        }), _hoisted_3, 16, _hoisted_1))
      : (_ctx.mode === 'create')
        ? (_openBlock(), _createElementBlock("button", _mergeProps({
            key: 1,
            class: "button is-primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal = _ctx.allowOpen))
          }, _ctx.$attrs, {
            disabled: !_ctx.allowOpen || undefined,
            title: _ctx.openButtonTitle
          }), " Create ", 16, _hoisted_4))
        : _createCommentVNode("", true),
    _createVNode(_component_Modal, {
      modelValue: _ctx.openModal,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.openModal) = $event)),
      title: _ctx.modalTitle,
      "is-large": ""
    }, {
      footer: _withCtx(({ close }) => [
        _createElementVNode("button", {
          class: "button",
          onClick: close
        }, "Cancel", 8, _hoisted_13),
        _createElementVNode("button", {
          type: "submit",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveAction && _ctx.saveAction(...args))),
          class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.loading }]),
          disabled: _ctx.loading || !_ctx.payload.name.length || undefined
        }, _toDisplayString(_ctx.saveButtonName), 11, _hoisted_14)
      ]),
      default: _withCtx(() => [
        _createElementVNode("form", {
          class: "form",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveAction && _ctx.saveAction(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", { 'is-danger': _ctx.fieldErrors.name }]),
                type: "text",
                maxlength: "100",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payload.name) = $event)),
                disabled: _ctx.loading || undefined
              }, null, 10, _hoisted_8), [
                [
                  _vModelText,
                  _ctx.payload.name,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.fieldErrors.name)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.fieldErrors.name, (err) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "help is-danger",
                      key: err
                    }, _toDisplayString(err), 1))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("textarea", {
                class: _normalizeClass(["textarea", { 'is-danger': _ctx.fieldErrors.description }]),
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payload.description) = $event)),
                disabled: _ctx.loading || undefined
              }, null, 10, _hoisted_12), [
                [
                  _vModelText,
                  _ctx.payload.description,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.fieldErrors.description)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.fieldErrors.description, (err) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "help is-danger",
                      key: err
                    }, _toDisplayString(err), 1))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}